import React, { useState } from "react";
import { ForesightPaymentSuccess } from "./ForesightPaymentSuccess";
import { StripeSubscription } from "../../../../components/stripeSubscription";
import { Switch } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { listOfSubscriptions } from "../../../../common/envConfig";
import moment from "moment";
import { axiosWithToken, functionBaseUrl } from "../../../../common/firebase";
import Swal from "sweetalert2";
import { PeriodSwitch } from "../AccountDetailsPlanChoice/PeriodSwitch";
import Divider from "../../../../components/shared/Divider/Divider";
import { IoMdInformationCircleOutline } from "react-icons/io";

export function ForesightPayment({ fullName, email, userId }) {
  const [successOpen, setSuccessOpen] = useState(false);
  const [subType, setSubType] = useState(
    listOfSubscriptions.FORESIGHT_ANNUALLY
  );

  const createSubscription = async (data) => {
    const input = {
      userId: userId,
      plan: subType.includes("monthly")
        ? "Foresight Monthly"
        : "Foresight Annually",
      planType: subType.includes("monthly") ? "Monthly" : "Annually",
      transactionId: data?.id,
      amount: String((data?.amount / 100).toFixed(2)),
      startDate: String(Date.now()),
      endDate: subType.includes("monthly")
        ? String(moment().add(1, "M").valueOf())
        : String(moment().add(1, "y").valueOf()),
      lastUpdated: String(Date.now()),
      autoRenewal: true,
      platform: "Stripe",
      productId: subType.includes("monthly")
        ? listOfSubscriptions.FORESIGHT_MONTHLY
        : listOfSubscriptions.FORESIGHT_ANNUALLY,
      userName: fullName,
      userEmail: email,
      promoCode: "",
      isAddOn: true,
    };

    await axiosWithToken(functionBaseUrl + "/api/partnerSub", {
      method: "POST",
      data: input,
    })
      .then(() => {
        setSuccessOpen(true);
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong! Please try again.",
          customClass: {
            container: "my-swal",
          },
        });
      });
  };

  const handleSubTypeChange = () => {
    setSubType((prev) => {
      if (prev === listOfSubscriptions.FORESIGHT_ANNUALLY) {
        return listOfSubscriptions.FORESIGHT_MONTHLY;
      } else {
        return listOfSubscriptions.FORESIGHT_ANNUALLY;
      }
    });
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center gap-8">
        <div className="w-full lg:w-[65%] p-2 rounded-xl border border-primary700 bg-primary50 flex items-start gap-2">
          <IoMdInformationCircleOutline className="size-6 min-w-6 text-primary700" />
          <div className="text-primary700 font-semibold">
            <div>Important information </div>
            <div>
              1. You will be charged separately from your current subscription,
              and billing date will not the same from your subscription dates.
            </div>
            {/* <div>
              2. To make any changes to your Foresight Integration, you will
              need to manage it via web.
            </div> */}
          </div>
        </div>
        <div className="w-full lg:w-[65%] p-6 rounded-xl border border-gray200 shadow-[0_1px_3px_0_rgba(14,24,41,0.10),_0_1px_2px_0_rgba(14,24,41,0.06)]">
          <PeriodSwitch
            isMonthly={subType === listOfSubscriptions.FORESIGHT_MONTHLY}
            onClick={handleSubTypeChange}
          />

          <img
            className="size-12"
            src={"/images/logos/foresight_logo.svg"}
            alt="Foresight Logo"
          />
          {/* <div className="font-semibold text-xl text-gray900">
            Foresight Integration (
            {subType === listOfSubscriptions.FORESIGHT_MONTHLY
              ? "Monthly"
              : "Annual"}
            )
          </div> */}
          <div className="text-base text-black">Auto renewal</div>

          <Divider className="my-6" color="gray200" type="horizontal"/>

          <div className="flex items-center justify-between">
            <div className="font-bold text-xl text-black">Subtotal</div>
            <div className="font-semibold text-xl text-black">
              $
              {subType === listOfSubscriptions.FORESIGHT_MONTHLY ? "40" : "400"}
            </div>
          </div>
        </div>
        <StripeSubscription
          email={email}
          productId={subType}
          handleResult={createSubscription}
          hideCoupon={true}
          fullName={fullName}
          showDetails={false}
        />
      </div>
      <ForesightPaymentSuccess
        isOpen={successOpen}
        onClose={() => window.location.reload()}
      />
    </>
  );
}
